import { render } from "./JewelryPreview.vue?vue&type=template&id=320dd862&scoped=true"
import script from "./JewelryPreview.vue?vue&type=script&lang=js"
export * from "./JewelryPreview.vue?vue&type=script&lang=js"

import "./JewelryPreview.vue?vue&type=style&index=0&id=320dd862&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320dd862"]])

export default __exports__